export const SITE = "https://zettakeep.io";
export const OG_IMAGE = `${SITE}/og-image.jpg`;

export const DEFAULT_TITLE = "ZettaKeep — Offsite Proxmox Backups in Minutes";
export const DEFAULT_DESC =
  "Order a fully managed, offsite Proxmox Backup Server (PBS 4.x) in minutes. Encrypted, deduplicated, verified and monitored offsite backups for Proxmox VE — no second datacenter required.";

// keyed by pathname. exactTitle=true uses the title verbatim (no " | ZettaKeep" suffix).
export const META = {
  "/": { title: DEFAULT_TITLE, description: DEFAULT_DESC, exactTitle: true },
  "/how-it-works": {
    title: "How It Works",
    description: "See how ZettaKeep provisions a managed offsite Proxmox Backup Server and connects it to your Proxmox VE in minutes — storage, region, retention and secure tokens, fully automated.",
  },
  "/pricing": {
    title: "Pricing",
    description: "Simple per-terabyte pricing for managed offsite Proxmox backups. Choose monthly or annual (two months free). No egress surprises, cancel anytime.",
  },
  "/features": {
    title: "Features",
    description: "Managed PBS, deduplication, nightly verification, flexible retention, encryption, monitoring and alerting — everything you need for reliable offsite Proxmox backups.",
  },
  "/security": {
    title: "Security",
    description: "End-to-end TLS, client-side encryption options, isolated per-customer storage and fully audited access for your offsite Proxmox backups.",
  },
  "/proxmox-backup": {
    title: "Managed Proxmox Backup Server",
    description: "A hosted Proxmox Backup Server (PBS 4.x) you attach to Proxmox VE — incremental deduplicated backups, verification and offsite retention, fully managed by ZettaKeep.",
  },
  "/msp": {
    title: "ZettaKeep for MSPs",
    description: "Multi-tenant offsite Proxmox backups for managed service providers — isolated per-client datastores, central billing, monitoring and margins.",
  },
  "/docs": {
    title: "Documentation",
    description: "Connect Proxmox VE to your ZettaKeep backup server: copyable CLI and web UI commands, API tokens, fingerprints and datastore setup.",
  },
  "/status": {
    title: "System Status",
    description: "Live operational status of ZettaKeep's control plane, provisioning pipeline and storage components.",
  },
  "/contact": {
    title: "Contact",
    description: "Talk to the ZettaKeep team about managed offsite Proxmox backups, MSP plans and custom retention.",
  },
  "/legal": {
    title: "Legal",
    description: "ZettaKeep legal documents — terms of service, privacy policy and data processing terms.",
  },
};

export const NOINDEX_PREFIXES = ["/app", "/admin", "/payment", "/login", "/signup"];

export const HOME_JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "ZettaKeep",
      url: SITE,
      logo: `${SITE}/favicon.svg`,
      description: DEFAULT_DESC,
    },
    { "@type": "WebSite", name: "ZettaKeep", url: SITE },
    {
      "@type": "SoftwareApplication",
      name: "ZettaKeep",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      description: DEFAULT_DESC,
      offers: { "@type": "Offer", priceCurrency: "USD", price: "0" },
    },
  ],
};
